import { render, staticRenderFns } from "./CardWrongUsageRepeater.vue?vue&type=template&id=6ec168de&scoped=true"
import script from "./CardWrongUsageRepeater.vue?vue&type=script&lang=js"
export * from "./CardWrongUsageRepeater.vue?vue&type=script&lang=js"
import style0 from "./CardWrongUsageRepeater.vue?vue&type=style&index=0&id=6ec168de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec168de",
  null
  
)

export default component.exports